module.exports = __webpack_public_path__ + "img/WEBP.6556c194.svg";